import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ConstantsService } from "../../constants.service";
import { MatSnackBar } from "@angular/material/snack-bar";
import { AuthService } from "../auth.service";
import { getAuthErrorMessage } from '../auth-error-message.util';

@Component({
  selector: 'app-mfa',
  templateUrl: './mfa.component.html',
  styleUrls: ['./mfa.component.scss']
})
export class MfaComponent implements OnInit {
  mfaForm: FormGroup = new FormGroup({});
  maskedEmail: string = '';
  token: string = '';
  apiUrl: string = '';
  isLoading: boolean = false;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private auth: AuthService,
    private constantsService: ConstantsService,
    private snackBar: MatSnackBar,
  ) {
    this.constantsService.onReady(() => {
      this.apiUrl = this.constantsService.getConstant('apiUrl');
      this.activatedRoute.queryParams.subscribe(params => {
        this.token = params['token'] || '';
        this.maskEmail(params['email'] || '');
        this.syncTokenToForm();
      });
    });
  }

  ngOnInit(): void {
    this.initMfaForm();
  }

  private initMfaForm() {
    this.mfaForm = new FormGroup({
      digit1: new FormControl('', [Validators.required, Validators.pattern(/[0-9]/)]),
      digit2: new FormControl('', [Validators.required, Validators.pattern(/[0-9]/)]),
      digit3: new FormControl('', [Validators.required, Validators.pattern(/[0-9]/)]),
      digit4: new FormControl('', [Validators.required, Validators.pattern(/[0-9]/)]),
      digit5: new FormControl('', [Validators.required, Validators.pattern(/[0-9]/)]),
      digit6: new FormControl('', [Validators.required, Validators.pattern(/[0-9]/)]),
      token: new FormControl(this.token, [Validators.required]),
    });
  }

  private syncTokenToForm(): void {
    if (this.mfaForm.contains('token')) {
      this.mfaForm.patchValue({ token: this.token }, { emitEvent: false });
    }
  }

  maskEmail(email: string): void {
    const emailParts = email.split('@');
    if (emailParts[0].length > 4) {
      const visiblePart = emailParts[0].substring(emailParts[0].length - 4);
      this.maskedEmail = `${'*'.repeat(emailParts[0].length - 4)}${visiblePart}@${emailParts[1].substring(0, 1)}***`;
    }
  }

  onKeydown(event: KeyboardEvent, nextInputId: number): void {
    const allowedKeys = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
    if (!allowedKeys.includes(event.key) && event.key !== 'Backspace') {
      event.preventDefault();
    } else if (event.key !== 'Backspace') {
      setTimeout(() => { // Timeout to delay focus to the next field
        const nextInput = document.getElementById(`digit${nextInputId + 1}`);
        if (nextInput) {
          nextInput.focus();
        }
      }, 10);
    }
  }

  onSubmit(): void {
    if (this.mfaForm.valid) {
      this.isLoading = true;
      const token = this.token || this.mfaForm.value.token;
      const otp = [
        this.mfaForm.value.digit1,
        this.mfaForm.value.digit2,
        this.mfaForm.value.digit3,
        this.mfaForm.value.digit4,
        this.mfaForm.value.digit5,
        this.mfaForm.value.digit6
      ].join('');
      this.auth.loginWithMfa(token, otp).then(() => {
        this.isLoading = false;
        this.router.navigate(['/shell']);
      }).catch((error: any) => {
        this.isLoading = false;
        console.error('Error during MFA verification:', error);
        this.snackBar.open(
          getAuthErrorMessage(error, 'An error occurred during MFA verification. Please try again.'),
          'Close',
          {
          duration: 3000,
          panelClass: ['error-snackbar']
          }
        );

        this.mfaForm.reset({
          digit1: '',
          digit2: '',
          digit3: '',
          digit4: '',
          digit5: '',
          digit6: '',
          token: this.token,
        });
      });
    }
  }
}
